// Onboarding Templates
// Based on the pig app designs

export const templates = [
    {
        id: 'blank',
        name: 'Blank Canvas',
        description: 'Start from scratch',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Welcome Screen',
                elements: [],
                backgroundColor: '#ffffff',
                width: 375,
                height: 812
            }
        ]
    },
    {
        id: 'pig-app',
        name: 'Pet Connection App',
        description: 'Cute onboarding flow for a pet care app',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Deepen Connection',
                backgroundColor: '#E8E4DF',
                width: 375,
                height: 812,
                elements: [
                    {
                        id: 'el-1',
                        type: 'image',
                        name: 'Pig Illustration',
                        x: 112,
                        y: 250,
                        width: 150,
                        height: 200,
                        imageUrl: 'https://raw.githubusercontent.com/twitter/twemoji/master/assets/72x72/1f437.png',
                        styles: {}
                    },
                    {
                        id: 'el-2',
                        type: 'text',
                        name: 'Title',
                        x: 30,
                        y: 520,
                        width: 315,
                        height: 80,
                        content: 'deepen your connection',
                        styles: {
                            fontSize: '32px',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            fontFamily: 'Poppins'
                        }
                    },
                    {
                        id: 'el-3',
                        type: 'text',
                        name: 'Subtitle',
                        x: 30,
                        y: 600,
                        width: 315,
                        height: 60,
                        content: 'by answering deep questions and taking care of your pet piggy',
                        styles: {
                            fontSize: '14px',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: '1.5',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-4',
                        type: 'dots-indicator',
                        name: 'Progress Dots',
                        x: 137,
                        y: 730,
                        width: 100,
                        height: 20,
                        totalScreens: 3,
                        currentScreen: 0,
                        styles: {}
                    },
                    {
                        id: 'el-5',
                        type: 'button',
                        name: 'Next Button',
                        x: 35,
                        y: 760,
                        width: 305,
                        height: 56,
                        content: 'Next',
                        action: 'next',
                        styles: {
                            backgroundColor: '#5D4037',
                            color: '#ffffff',
                            fontSize: '18px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            fontFamily: 'Inter'
                        }
                    }
                ]
            },
            {
                id: 'screen-2',
                name: 'Keep Love Alive',
                backgroundColor: '#E8E4DF',
                width: 375,
                height: 812,
                elements: [
                    {
                        id: 'el-6',
                        type: 'image',
                        name: 'Pig with Heart',
                        x: 112,
                        y: 250,
                        width: 150,
                        height: 200,
                        imageUrl: 'https://raw.githubusercontent.com/twitter/twemoji/master/assets/72x72/1f437.png',
                        styles: {}
                    },
                    {
                        id: 'el-7',
                        type: 'text',
                        name: 'Title',
                        x: 30,
                        y: 520,
                        width: 315,
                        height: 80,
                        content: 'keep the love alive',
                        styles: {
                            fontSize: '32px',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            fontFamily: 'Poppins'
                        }
                    },
                    {
                        id: 'el-8',
                        type: 'text',
                        name: 'Subtitle',
                        x: 30,
                        y: 600,
                        width: 315,
                        height: 60,
                        content: 'by sending love letters, playing games, and doing check-ins',
                        styles: {
                            fontSize: '14px',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: '1.5',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-9',
                        type: 'dots-indicator',
                        name: 'Progress Dots',
                        x: 137,
                        y: 730,
                        width: 100,
                        height: 20,
                        totalScreens: 3,
                        currentScreen: 1,
                        styles: {}
                    },
                    {
                        id: 'el-10',
                        type: 'button',
                        name: 'Next Button',
                        x: 35,
                        y: 760,
                        width: 305,
                        height: 56,
                        content: 'Next',
                        action: 'next',
                        styles: {
                            backgroundColor: '#5D4037',
                            color: '#ffffff',
                            fontSize: '18px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            fontFamily: 'Inter'
                        }
                    }
                ]
            },
            {
                id: 'screen-3',
                name: 'Get Reminders',
                backgroundColor: '#E8E4DF',
                width: 375,
                height: 812,
                elements: [
                    {
                        id: 'el-11',
                        type: 'image',
                        name: 'Pig with Phone',
                        x: 112,
                        y: 250,
                        width: 150,
                        height: 200,
                        imageUrl: 'https://raw.githubusercontent.com/twitter/twemoji/master/assets/72x72/1f437.png',
                        styles: {}
                    },
                    {
                        id: 'el-12',
                        type: 'text',
                        name: 'Title',
                        x: 30,
                        y: 520,
                        width: 315,
                        height: 80,
                        content: 'get a constant reminder',
                        styles: {
                            fontSize: '32px',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            fontFamily: 'Poppins'
                        }
                    },
                    {
                        id: 'el-13',
                        type: 'text',
                        name: 'Subtitle',
                        x: 30,
                        y: 600,
                        width: 315,
                        height: 80,
                        content: 'get new love letters right to your homescreen using our widgets + track days together and your partners mood!',
                        styles: {
                            fontSize: '14px',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: '1.5',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-14',
                        type: 'dots-indicator',
                        name: 'Progress Dots',
                        x: 137,
                        y: 730,
                        width: 100,
                        height: 20,
                        totalScreens: 3,
                        currentScreen: 2,
                        styles: {}
                    },
                    {
                        id: 'el-15',
                        type: 'button',
                        name: 'Get Started Button',
                        x: 35,
                        y: 760,
                        width: 305,
                        height: 56,
                        content: 'Get Started',
                        action: 'next',
                        styles: {
                            backgroundColor: '#5D4037',
                            color: '#ffffff',
                            fontSize: '18px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            fontFamily: 'Inter'
                        }
                    }
                ]
            }
        ]
    },
    {
        id: 'saas-welcome',
        name: 'SaaS Welcome',
        description: 'Clean onboarding for SaaS products',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Welcome',
                backgroundColor: '#ffffff',
                width: 375,
                height: 812,
                elements: [
                    {
                        id: 'el-1',
                        type: 'text',
                        name: 'Welcome Title',
                        x: 30,
                        y: 200,
                        width: 315,
                        height: 100,
                        content: 'Welcome to the Future',
                        styles: {
                            fontSize: '36px',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-2',
                        type: 'text',
                        name: 'Subtitle',
                        x: 30,
                        y: 320,
                        width: 315,
                        height: 60,
                        content: 'Get started in just a few steps',
                        styles: {
                            fontSize: '18px',
                            textAlign: 'center',
                            color: '#666666',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-3',
                        type: 'button',
                        name: 'Get Started',
                        x: 35,
                        y: 700,
                        width: 305,
                        height: 56,
                        content: 'Get Started',
                        action: 'next',
                        styles: {
                            backgroundColor: '#3b82f6',
                            color: '#ffffff',
                            fontSize: '18px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            fontFamily: 'Inter'
                        }
                    }
                ]
            }
        ]
    },
    {
        id: 'simple-3-screen',
        name: 'Simple 3-Screen',
        description: 'Classic welcome, features, and get started flow',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Welcome',
                backgroundColor: '#ffffff',
                width: 375,
                height: 812,
                elements: [
                    { type: 'text', content: 'Welcome to App', x: 30, y: 200, width: 315, height: 60, styles: { fontSize: '32px', fontWeight: 'bold', textAlign: 'center' } },
                    { type: 'text', content: 'The best way to get started.', x: 30, y: 280, width: 315, height: 40, styles: { fontSize: '16px', textAlign: 'center', color: '#666' } },
                    { type: 'button', content: 'Next', action: 'next', x: 30, y: 700, width: 315, height: 50, styles: { backgroundColor: '#000', color: '#fff', borderRadius: '25px' } },
                    { type: 'dots-indicator', totalScreens: 3, currentScreen: 0, x: 137, y: 650, width: 100, height: 20 }
                ]
            },
            {
                id: 'screen-2',
                name: 'Features',
                backgroundColor: '#ffffff',
                width: 375,
                height: 812,
                elements: [
                    { type: 'text', content: 'Amazing Features', x: 30, y: 200, width: 315, height: 60, styles: { fontSize: '32px', fontWeight: 'bold', textAlign: 'center' } },
                    { type: 'text', content: 'Discover what you can do.', x: 30, y: 280, width: 315, height: 40, styles: { fontSize: '16px', textAlign: 'center', color: '#666' } },
                    { type: 'button', content: 'Next', action: 'next', x: 30, y: 700, width: 315, height: 50, styles: { backgroundColor: '#000', color: '#fff', borderRadius: '25px' } },
                    { type: 'dots-indicator', totalScreens: 3, currentScreen: 1, x: 137, y: 650, width: 100, height: 20 }
                ]
            },
            {
                id: 'screen-3',
                name: 'Get Started',
                backgroundColor: '#ffffff',
                width: 375,
                height: 812,
                elements: [
                    { type: 'text', content: 'Ready to Dive In?', x: 30, y: 200, width: 315, height: 60, styles: { fontSize: '32px', fontWeight: 'bold', textAlign: 'center' } },
                    { type: 'button', content: 'Let\'s Go', action: 'next', x: 30, y: 700, width: 315, height: 50, styles: { backgroundColor: '#000', color: '#fff', borderRadius: '25px' } },
                    { type: 'dots-indicator', totalScreens: 3, currentScreen: 2, x: 137, y: 650, width: 100, height: 20 }
                ]
            }
        ]
    },
    {
        id: 'email-capture',
        name: 'Email Capture',
        description: 'Collect user emails upfront',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Sign Up',
                backgroundColor: '#ffffff',
                width: 375,
                height: 812,
                elements: [
                    { type: 'text', content: 'Stay Updated', x: 30, y: 150, width: 315, height: 60, styles: { fontSize: '32px', fontWeight: 'bold', textAlign: 'center' } },
                    { type: 'text', content: 'Enter your email to get the latest news.', x: 30, y: 220, width: 315, height: 40, styles: { fontSize: '16px', textAlign: 'center', color: '#666' } },
                    { type: 'input', placeholder: 'your@email.com', variable: 'email', x: 30, y: 300, width: 315, height: 50, styles: { border: '1px solid #ccc', borderRadius: '8px', padding: '10px' } },
                    { type: 'button', content: 'Continue', action: 'next', x: 30, y: 380, width: 315, height: 50, styles: { backgroundColor: '#000', color: '#fff', borderRadius: '25px' } }
                ]
            }
        ]
    },
    {
        id: 'paywall',
        name: 'Paywall Ready',
        description: 'High conversion paywall screen',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Choose Plan',
                backgroundColor: '#ffffff',
                width: 375,
                height: 812,
                elements: [
                    { type: 'text', content: 'Unlock Premium', x: 30, y: 100, width: 315, height: 60, styles: { fontSize: '32px', fontWeight: 'bold', textAlign: 'center' } },
                    { type: 'text', content: 'Get unlimited access to all features.', x: 30, y: 160, width: 315, height: 40, styles: { fontSize: '16px', textAlign: 'center', color: '#666' } },
                    // Mock plan cards using shapes/text
                    { type: 'shape', x: 30, y: 250, width: 315, height: 100, styles: { backgroundColor: '#f0f0f0', borderRadius: '12px' } },
                    { type: 'text', content: 'Monthly - $9.99', x: 50, y: 270, width: 200, height: 30, styles: { fontSize: '18px', fontWeight: 'bold' } },
                    { type: 'text', content: '7-day free trial', x: 50, y: 300, width: 200, height: 20, styles: { fontSize: '14px', color: '#666' } },

                    { type: 'shape', x: 30, y: 370, width: 315, height: 100, styles: { backgroundColor: '#e0e7ff', borderRadius: '12px', border: '2px solid #3b82f6' } },
                    { type: 'text', content: 'Yearly - $99.99', x: 50, y: 390, width: 200, height: 30, styles: { fontSize: '18px', fontWeight: 'bold' } },
                    { type: 'text', content: 'Save 20%', x: 50, y: 420, width: 200, height: 20, styles: { fontSize: '14px', color: '#3b82f6', fontWeight: 'bold' } },

                    { type: 'button', content: 'Start Free Trial', action: 'next', x: 30, y: 700, width: 315, height: 50, styles: { backgroundColor: '#3b82f6', color: '#fff', borderRadius: '25px' } }
                ]
            }
        ]
    },
    {
        id: 'fast-onboarding',
        name: 'Fast Onboarding',
        description: 'TikTok style full screen video/image',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Swipe Up',
                backgroundColor: '#000000',
                width: 375,
                height: 812,
                elements: [
                    { type: 'image', imageUrl: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80', x: 0, y: 0, width: 375, height: 812, styles: { objectFit: 'cover', opacity: '0.6' } },
                    { type: 'text', content: 'Watch & Learn', x: 30, y: 600, width: 315, height: 60, styles: { fontSize: '32px', fontWeight: 'bold', color: '#fff', textShadow: '0 2px 4px rgba(0,0,0,0.5)' } },
                    { type: 'text', content: 'Swipe to continue', x: 30, y: 670, width: 315, height: 30, styles: { fontSize: '16px', color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,0.5)' } },
                    { type: 'button', content: 'Next', action: 'next', x: 30, y: 730, width: 315, height: 50, styles: { backgroundColor: '#fff', color: '#000', borderRadius: '25px' } }
                ]
            }
        ]
    }
];

export default templates;
